module.exports = __webpack_public_path__ + "static/media/ninjaEvaluation.00584fd4.webp";